import "./styles.css";
import { App } from "./app";

const app = new App(document.getElementById("app")!);
app.start().then(() => app.route());

// The offline shell (public/sw.js), in production builds only.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
